export default "__VITE_ASSET__185fdaf3__"